import TextInput from 'components/input-field/TextInput';
import Loader from 'components/loader/Loader';
import React, { Component } from 'react'
import { Form, Formik } from 'formik';
import { Col } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SelectInput from 'components/input-field/SelectInput';
import SaveButton from 'components/buttons/SaveButton';
import { HairTestReportRes, HairTestReportTodo } from 'redux/slice/admin/text-report/hair-report/HairReport';
import { toast, ToastContainer } from 'react-toastify';
import { TissueBiopsyTestRes, TissueBiopsyTestTodo } from 'redux/slice/admin/text-report/tissue-biopsy/TissueBiopsyTest';

class TissueBiopsyTest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spiner: false,
            dataRes: '',
            values: {
                biopsy_site: '',
                cell_morphology: '',
                malignant_cell_type: '',
                tissue_architecture: '',
                inflammation_type: '',
                inflammation_severity: '',
                necrosis_extent: '',
                fibrosis_extent: '',
                staining_method: '',
                sample_size: '',
                inflammation_presence: '',
                necrosis_presence: '',
                fibrosis_presence: '',

            }
        };
    }


    biopsySite = [
        { "value": 'Liver', "label": "Liver" },
        { "value": 'Breast', "label": "Breast" },
        { "value": 'Lung', "label": "Lung" },
        { "value": 'Prostate', "label": "Prostate" },
        { "value": 'Skin', "label": "Skin" },
    ]

    cellMorphology = [
        { "value": 'Atypical', "label": "Atypical" },
        { "value": 'Dysplastic', "label": "Dysplastic" },
        { "value": 'Anaplastic', "label": "Anaplastic" },
    ]

    malignantCellType = [
        { "value": 'Invasive Ductal Carcinoma', "label": "Invasive Ductal Carcinoma" },
        { "value": 'Adenocarcinoma', "label": "Adenocarcinoma" },
        { "value": 'Squamous Cell Carcinoma', "label": "Squamous Cell Carcinoma" },
        { "value": 'None', "label": "None" },
    ]
    tissueAarchitecture = [
        { "value": 'Normal', "label": "Normal" },
        { "value": 'Disordered', "label": "Disordered" },
        { "value": 'Infiltrative', "label": "Infiltrative" },
        { "value": 'Destructive', "label": "Destructive" },
    ]
    inflammationType = [
        { "value": 'Acute', "label": "Acute" },
        { "value": 'Chronic', "label": "Chronic" },
        { "value": 'Granulomatous', "label": "Granulomatous" },
        { "value": 'None', "label": "None" },
    ]
    inflammationSeverity = [
        { "value": 'Mild', "label": "Mild" },
        { "value": 'Moderate', "label": "Moderate" },
        { "value": 'Severe', "label": "Severe" },
        { "value": 'None', "label": "None" },
    ]

    necrosisExtent = [
        { "value": 'Focal', "label": "Focal" },
        { "value": 'Diffuse', "label": "Diffuse" },
        { "value": 'Massive', "label": "Massive" },
        { "value": 'None', "label": "None" },
    ]
    fibrosisExtent = [
        { "value": 'Mild', "label": "Mild" },
        { "value": 'Moderate', "label": "Moderate" },
        { "value": 'Severe', "label": "Severe" },
        { "value": 'None', "label": "None" },
    ]
    stainingMethod = [
        { "value": 'Hematoxylin and Eosin', "label": "Hematoxylin and Eosin" },
        { "value": 'Masson’s Trichrome', "label": "Masson’s Trichrome" },
        { "value": 'Periodic acid–Schiff', "label": "Periodic acid–Schiff" },
    ]




    handleSubmit = (values) => {
        // this.setState({ spiner: true });
        const { dispatch } = this.props;
        console.log(values)
        dispatch(TissueBiopsyTestTodo(values)).then(() => this.add_res());
    }

    add_res = () => {
        // if (HairTestReportRes?.success) {
        //     toast.success(HairTestReportRes?.message, { position: "bottom-right" });
        //     this.setState({ spiner: false, dataRes: HairTestReportRes?.data, });


        // } else {
        //     toast.error(HairTestReportRes?.message, { position: "bottom-right" });
        //     this.setState({ spiner: false });
        //     this.state({ dataRes: '' })
        // }
        toast.success(TissueBiopsyTestRes?.prediction_result, { position: "bottom-right" });
        this.setState({ spiner: false, dataRes: TissueBiopsyTestRes?.data, });
    }
  render() {
    return (
   <>
      <div className="page-content">
                    <div className="container-fluid">
                        <h4 className="mb-0 font-size-18">Hair Analysis Prediction</h4>
                        <div className="row">
                            <div className="col-md-12">
                                <div className='form_layout'>
                                    {/* {this.state.spiner ?
                                        <div className='d-flex justify-content-center p-5'>
                                            <Loader />
                                        </div> : */}

                                        <Formik
                                            initialValues={this.state.values}
                                            // validationSchema={HairTestSchema}
                                            onSubmit={this.handleSubmit}
                                        >
                                            {({
                                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                                <Form >
                                                    <div className="row">
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Biopsy Site'
                                                                disabled={false}
                                                                options={this.biopsySite}
                                                                name='biopsy_site'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('biopsy_site', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.biopsy_site && touched.biopsy_site ? (<span className='text-danger form_label' >{errors.biopsy_site}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Cell Morphology'
                                                                disabled={false}
                                                                options={this.cellMorphology}
                                                                name='cell_morphology'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('cell_morphology', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.cell_morphology && touched.cell_morphology ? (<span className='text-danger form_label' >{errors.cell_morphology}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Malignant Cell Type'
                                                                disabled={false}
                                                                options={this.malignantCellType}
                                                                name='malignant_cell_type'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('malignant_cell_type', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.malignant_cell_type && touched.malignant_cell_type ? (<span className='text-danger form_label' >{errors.malignant_cell_type}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Tissue Architecture'
                                                                disabled={false}
                                                                options={this.tissueAarchitecture}
                                                                name='tissue_architecture'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('tissue_architecture', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.tissue_architecture && touched.tissue_architecture ? (<span className='text-danger form_label' >{errors.tissue_architecture}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Inflammation Type'
                                                                disabled={false}
                                                                options={this.inflammationType}
                                                                name='inflammation_type'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('inflammation_type', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.inflammation_type && touched.inflammation_type ? (<span className='text-danger form_label' >{errors.inflammation_type}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Inflammation Severity'
                                                                disabled={false}
                                                                options={this.inflammationSeverity}
                                                                name='inflammation_severity'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('inflammation_severity', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.inflammation_severity && touched.inflammation_severity ? (<span className='text-danger form_label' >{errors.inflammation_severity}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Necrosis Extent'
                                                                disabled={false}
                                                                options={this.necrosisExtent}
                                                                name='necrosis_extent'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('necrosis_extent', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.necrosis_extent && touched.necrosis_extent ? (<span className='text-danger form_label' >{errors.necrosis_extent}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Fibrosis Extent'
                                                                disabled={false}
                                                                options={this.fibrosisExtent}
                                                                name='fibrosis_extent'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('fibrosis_extent', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.fibrosis_extent && touched.fibrosis_extent ? (<span className='text-danger form_label' >{errors.fibrosis_extent}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <SelectInput
                                                                closeMenu={true}
                                                                label_name='Staining Method'
                                                                disabled={false}
                                                                options={this.stainingMethod}
                                                                name='staining_method'
                                                                defaultValue={''}
                                                                onChange={(e) =>
                                                                    setFieldValue('staining_method', e.value)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={errors.staining_method && touched.staining_method ? (<span className='text-danger form_label' >{errors.staining_method}</span>) : null} />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <TextInput
                                                                label_name='Sample Size'
                                                                placeholder=''
                                                                name='sample_size'
                                                                value={values.sample_size || ''}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={errors.sample_size && touched.sample_size ? (<span className='text-danger form_label' >{errors.sample_size}</span>) : null}
                                                            />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <TextInput
                                                                label_name='Inflammation Presence'
                                                                placeholder=''
                                                                name='inflammation_presence'
                                                                value={values.inflammation_presence || ''}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={errors.inflammation_presence && touched.inflammation_presence ? (<span className='text-danger form_label' >{errors.inflammation_presence}</span>) : null}
                                                            />
                                                        </Col>
                                                        <Col xl='4'>
                                                            <TextInput
                                                                label_name='Necrosis Presence'
                                                                placeholder=''
                                                                name='necrosis_presence'
                                                                value={values.necrosis_presence || ''}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={errors.necrosis_presence && touched.necrosis_presence ? (<span className='text-danger form_label' >{errors.necrosis_presence}</span>) : null}
                                                            />
                                                        </Col>

                                                        <Col xl='4'>
                                                            <TextInput
                                                                label_name='Fibrosis Presence'
                                                                placeholder=''
                                                                name='fibrosis_presence'
                                                                value={values.fibrosis_presence || ''}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={errors.fibrosis_presence && touched.fibrosis_presence ? (<span className='text-danger form_label' >{errors.fibrosis_presence}</span>) : null}
                                                            />
                                                        </Col>
                                                  
                                                        <Col xl='12' className=' d-flex justify-content-end'>
                                                            {/* <SaveButton name={'Predict'} /> */}
                                                            <button className="add_btn ps-3 pe-3 "  type="submit" disabled={this.state?.spiner ? true : false} >
                                                        {this.state?.spiner ? <>  <span className='ps-1'>Loading....</span> <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                        </> : <span >  PREDICT</span>}
                                                    </button>
                                                        </Col>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    {/* } */}
                                </div>
                            </div>
                            {this.state.dataRes ? (
                                <div className='row d-flex justify-content-center'>
                                    <div className="col-md-6">
                                        <div className="predit_res">
                                            <h3 className={this.state.dataRes?.prediction_result === "Positive for fungal presence" ? 'positive' : 'negative'}>{this.state.dataRes?.prediction_result}</h3>
                                        </div>
                                    </div>
                                </div>

                            ) : null}
                        </div>
                    </div>
                </div>
                <ToastContainer />
   </>
    )
  }
}

export default connect()(withRouter(TissueBiopsyTest));
